<script setup>
defineProps({
  quote: { type: Object, required: true },
});
</script>

<template>
  <div class="quote-block">
    <div class="quote-block__container">
      <div class="quote-block__text">
        <PostContent :content="quote.content" is-section-quote />
      </div>
      <div class="quote-block__author">
        <BaseAvatar size="big" :image="quote.author.image" />
        <div class="quote-block__author-name">
          {{ quote.author.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.quote-block {
  max-width: var(--content-max-width);
  margin: 0 auto;
  padding: 24px 60px 40px;

  &__container {
    max-width: 1107px;
    margin: 0 auto;
  }

  &__text {
    position: relative;
    z-index: 1;
    margin-bottom: 24px;
    font-size: 24px;
    line-height: 32px;

    &::after,
    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      width: 90px;
      height: 90px;
      background-image: url('~/assets/images/quote-yellow.svg');
      background-repeat: no-repeat;
      background-size: cover;
    }

    &::before {
      top: 0;
      bottom: auto;
      left: -100px;
      right: auto;
    }

    &::after {
      top: auto;
      bottom: 0;
      left: auto;
      right: -100px;
      transform: rotate(180deg);
    }
  }

  &__author {
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 24px;
    line-height: 24px;
    font-weight: 700;
  }

  &__author-name {
    width: min-content;
  }

  @media (--small-vp) {
    padding: 40px 8px 20px;

    &__text {
      margin-bottom: 8px;
      font-size: 18px;
      line-height: 22px;

      &::after,
      &::before {
        width: 40px;
        height: 40px;
        background-size: 40px 40px;
      }

      &::before {
        top: -10px;
        bottom: auto;
        left: -20px;
        right: auto;
      }

      &::after {
        top: auto;
        bottom: -10px;
        left: auto;
        right: -20px;
      }
    }

    &__author {
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
